import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPartRequestDetails } from "../../reduxStore/entities/partRequest";
import EngineDisplacementSVG from "../../assets/icons/svg/EngineDisplacementSVG";
import ThumbUpSVG from "../../assets/icons/svg/ThumbUpSVG";
import ThumbDownSVG from "../../assets/icons/svg/ThumbDownSVG";
import { partRequestsPartstateOptions } from "../../../../utils/mapRequestStates";
import PowerIconSVG from "../../assets/icons/svg/PowerIconSVG";
import FuelIconSVG from "../../assets/icons/svg/FuelIconSVG";
import CopyIconSVG from "../../assets/icons/svg/CopyIconSVG";
import Breadcrumb from '../../../SharedComponents/components/Breadcrumb/Breadcrumb';
import { getStateLabel } from "../../utils/helpers/getStateLabel";
import { getSinglePartOffer } from "../../reduxStore/entities/partOffers";
import ArrowBackSVG from "../../assets/icons/svg/ArrowBackSVG";
import LocationIconSVG from "../../assets/icons/svg/LocattionIconSVG";
import MailIconSVG from "../../assets/icons/svg/MailIconSVG";
import PhoneIconSVG from "../../assets/icons/svg/PhoneIconSVG";
import CheckedIconSVG from "../../assets/icons/svg/CheckedIconSVG";
import AlertIconSVG from "../../assets/icons/svg/AlertIconSVG";
import OfferImageGallery from "./OfferImageGallery";
import ChatSidebar from "./MessageDrawer/ChatSideBar";
import api from "../../../../api";
import RatePage from "../RequestComponents/RatePage";

const OfferDetails = ({ id, onBack }) => {
    const [copySuccess, setCopySuccess] = useState(false);
    const dispatch = useDispatch();
    const partOfferDetails = useSelector((state) => state.partOffers.singlePartOffer);
    const partRequestDetails = useSelector(state => state.partRequests.partRequestDetails);
    const [email, setEmail] = useState("");
    const [showRatePage, setShowRatePage] = useState(false);



    useEffect(() => {
        if (partOfferDetails?.PartRequest?.part_request_id) {
            dispatch(getPartRequestDetails({ id: Number(partOfferDetails.PartRequest.part_request_id) }));
        }
    }, [partOfferDetails?.PartRequest?.part_request_id, dispatch]);

    const getEmail = async (userId) => {
        try {
            if (!userId) return;
            const response = await api.get(`/user/${userId}`);
            const email = response?.data?.email;
            return email;
        } catch (error) {
            console.error("Greška prilikom poziva /user/:id:", error);
            return null;
        }
    };

    useEffect(() => {
        if (id) {
            dispatch(getSinglePartOffer({ id: Number(id) }));
        }
    }, [id, dispatch]);

    useEffect(() => {
        const fetchEmail = async () => {
            if (partOfferDetails && partOfferDetails?.PartRequest?.User?.userid) {
                const result = await getEmail(partOfferDetails.PartRequest.User.userid);
                setEmail(result);
            }
        };

        fetchEmail();
    }, [partOfferDetails?.PartRequest?.User?.userid]);
    if (!partRequestDetails || !partOfferDetails) return <div>Učitavanje…</div>;

    const handleCopyVin = () => {
        if (partRequestDetails.vin) {
            navigator.clipboard.writeText(partRequestDetails.vin);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
        }
    };
    const handlePartSentClick = () => {
        setShowRatePage(true);
    };

    const handleRatePageBack = () => {
        setShowRatePage(false);
    };




    const stateLabel = getStateLabel(partOfferDetails?.status);
    const getType = () => {
        return partOfferDetails.type === "used"
            ? "Polovan deo"
            : partOfferDetails.type === "new"
                ? "Nov deo"
                : "";
    };

    const breadcrumbs = [
        { title: 'Početak', href: '/home-page' },
        { title: 'Ponude', href: '/offers' },
        { title: `Ponuda – ${partOfferDetails.title}`, href: '#' }
    ];
    return (
        <div style={styles.container}>
            <div style={styles.headerWrapper}>
                <h1 style={styles.headerTitle}>
                    <div style={styles.iconContainer} onClick={onBack}>
                        <ArrowBackSVG />
                        {`Ponuda – ${partOfferDetails.title}`}
                    </div>                </h1>
                <div style={{
                    ...styles.stateLabel,
                    backgroundColor: stateLabel === "Odbijena" ? "red" : "green"
                }}>
                    {stateLabel}
                </div>
            </div>

            <div style={styles.breadcrumbWrapper}>
                <Breadcrumb breadcrumbs={breadcrumbs} />
            </div>

            <div style={styles.card}>
                <h2 style={styles.cardTitle}>
                    {partRequestDetails.Make?.name}  <strong>{partRequestDetails.Model?.name}</strong> – {partRequestDetails.Generation?.name?.match(/\d{2}\.\d{4}-\d{2}\.\d{4}/)?.[0] || "Godine nepoznate"}
                </h2>
                <div style={styles.carDetails}>
                    <span><EngineDisplacementSVG />{partRequestDetails.Motor?.name}</span>
                    <span><PowerIconSVG />{partRequestDetails.Motor?.name}</span>
                    <span><FuelIconSVG />{partRequestDetails.Motor?.name}</span>
                </div>
                <div style={styles.vinContainer}>
                    <p style={styles.vinComponent}>
                        Broj šasije: <code style={styles.vinCode}>{partRequestDetails.vin || "N/A"}</code>
                        {partRequestDetails.vin && (
                            <span onClick={handleCopyVin} style={styles.copyLink}>
                                <CopyIconSVG /> Kopiraj
                            </span>
                        )}
                    </p>
                    {copySuccess && <p style={styles.copySuccess}>Kopirano!</p>}
                </div>
            </div>

            <div style={styles.card}>
                {partRequestDetails.PartRequestImages?.[0]?.url && (
                    <img
                        src={partRequestDetails.PartRequestImages[0].small_part_request_image_url}
                        alt="Zahtev slika"
                        style={styles.imageThumb}
                    />
                )}

                <div style={styles.requestDetails}>
                    <div style={styles.requestHeader}>
                        <h3 style={styles.requestTitle}>
                            {partRequestDetails.title?.split(" - ")[0] || ""} ▪{" "}
                            {
                                partRequestsPartstateOptions().find(opt => opt.value === partRequestDetails.partstate)?.label || "Stanje nepoznato"
                            }
                        </h3>
                        <div style={styles.userDetails}>
                            <p style={styles.userCity}>
                                {partRequestDetails.User?.city || "Nepoznat grad"}
                            </p>
                            <p style={styles.userRating}>
                                <ThumbUpSVG /> {partRequestDetails.User?.positive_rated_as_buyer || 0}
                                <ThumbDownSVG /> {partRequestDetails.User?.negative_rated_as_buyer || 0}
                            </p>
                        </div>
                    </div>

                    <p style={styles.description}>
                        {partRequestDetails.description || "Nema opisa"}
                    </p>
                </div>
            </div>

            <div style={styles.offerWrapper}>
                <h2 style={styles.offerHeader}>
                    Moja ponuda - {partOfferDetails.title}
                </h2>

                <div style={styles.offerContent}>
                    <div style={styles.imageGroup}>
                        <OfferImageGallery images={partOfferDetails.PartOfferImages} />

                    </div>

                    <div style={styles.offerInfo}>
                        <p style={styles.offerPrice}>
                            {partOfferDetails.price} EUR
                        </p>

                        <p style={styles.offerType}>
                            {getType()} ▪ {partOfferDetails.guarantee ? `Garancija ${partOfferDetails.guarantee}` : "Bez garancije"}
                        </p>

                        <p style={styles.offerDelivery}>
                            {partOfferDetails.delivery}
                        </p>

                        <p style={styles.offerDescription}>
                            {partOfferDetails.description}
                        </p>
                    </div>
                </div>
            </div>
            <div style={styles.buyerCard}>
                <h2 style={styles.buyerTitle}>Kupac</h2>
                <p style={styles.buyerName}>
                    {partOfferDetails?.PartRequest?.User.firstname}{" "}{partOfferDetails?.PartRequest.User.lastname}
                    <span style={styles.rating}>
                        <ThumbUpSVG /> {partOfferDetails?.PartRequest.User?.positive_rated_as_buyer || 0}
                        <ThumbDownSVG style={styles.iconComponent} /> {partOfferDetails?.PartRequest.User?.negative_rated_as_buyer || 0}
                    </span>
                </p>

                <p><strong><LocationIconSVG /></strong> {partOfferDetails?.PartRequest.User?.address}{","}{partOfferDetails?.PartRequest.User?.city}</p>
                <p><strong><MailIconSVG /></strong> {email || "Email nije dostupan"}</p>
                <p><strong><PhoneIconSVG /></strong> {partOfferDetails?.PartRequest.User?.phone || "Telefon nije dostupan"}</p>

                <h3 style={styles.buyerTitle}>Upravljanje ponudom</h3>
                <div style={styles.buttonGroup}>
                    <div>
                        {!showRatePage && (
                            <div>
                                <button style={styles.buyerButton} onClick={handlePartSentClick}>
                                    Poslao sam deo <CheckedIconSVG />
                                </button>
                            </div>
                        )}

                        {showRatePage && (
                            <RatePage
                                onBack={handleRatePageBack}
                                partRequestId={partOfferDetails?.PartRequest?.part_request_id}
                                userIdBuyer={partOfferDetails?.PartRequest?.User.userid}
                                userFirstName={partOfferDetails?.PartRequest?.User.firstname}
                                userLastName={partOfferDetails?.PartRequest.User.lastname}

                            />

                        )}
                    </div>
                    <button style={styles.buyerButton}>Prijavi problem <AlertIconSVG /></button>
                </div>
            </div>
            {!showRatePage && (

                <ChatSidebar
                    partOfferStatus={partOfferDetails.status}
                    partOfferId={partOfferDetails.part_offer_id
                    }
                    conversationUserIds={[partOfferDetails.User.userid, partOfferDetails.PartRequest.User.userid]}
                    partOfferCreatedAt={partOfferDetails.createdAt}
                />
            )}

        </div>

    );
};

export default OfferDetails;

const styles = {
    container: {
        padding: 24,
        backgroundColor: "white",
    },
    iconContainer: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        gap: 10
    },
    iconComponent: {
        marginLeft: 8
    },
    headerWrapper: {
        marginBottom: 8,
        marginTop: 20,
        display: "flex",
        alignItems: "center",
        gap: 12
    },
    headerTitle: {

        color: "rgba(0, 0, 0, 0.87)",
        fontSize: 34,
        fontWeight: 400,
        letterSpacing: 0.25,
    },
    stateLabel: {
        padding: "4px 10px",
        borderRadius: "999px",
        color: "white",
        fontWeight: 600,
        fontSize: "12px",
        whiteSpace: "nowrap",
        height: 24,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 70
    },


    breadcrumbWrapper: {
        marginBottom: 30
    },
    card: {
        backgroundColor: "#f8f9fa",
        padding: 16,
        borderRadius: 8,
        display: "flex",
        flexDirection: "column",
        marginBottom: 32,
        border: "1px solid #ccc"
    },
    cardTitle: {
        margin: 0
    },
    carDetails: {
        marginTop: 8,
        display: "flex",
        gap: 16,
        flexWrap: "wrap"
    },
    vinContainer: {
        display: "flex",
        flexDirection: "column",
        gap: 4,
        marginTop: 8
    },
    vinComponent: {
        margin: 0
    },
    vinCode: {
        color: "black"
    },
    copyLink: {
        color: "rgba(91, 33, 182, 1)",
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        marginLeft: 8
    },
    copySuccess: {
        fontSize: 12,
        color: "#888",
        margin: 0,
        marginLeft: 8
    },
    imageThumb: {
        width: 100,
        height: 100,
        objectFit: "cover",
        borderRadius: 8
    },
    requestDetails: {
        flex: 1,
        display: "flex",
        flexDirection: "column"
    },
    requestHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start"
    },
    requestTitle: {
        margin: 0,
        fontWeight: "bold",
        fontSize: 18
    },
    userDetails: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 12
    },
    userCity: {
        margin: 0,
        fontWeight: "bold"
    },
    userRating: {
        margin: 0,
        display: "flex",
        gap: 8,
        alignItems: "center"
    },
    description: {
        marginTop: 8
    },
    offerWrapper: {
        padding: 16,
        marginBottom: 32
    },
    offerHeader: {
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: 24,
        fontWeight: 600,
        marginBottom: 24
    },
    offerContent: {
        display: "flex",
        flexDirection: "row",
        gap: 24
    },
    imageGroup: {
        display: "flex",
        flexDirection: "column",
        gap: 12
    },
    imageThumbLarge: {
        width: 200,
        height: 160,
        objectFit: "cover",
        borderRadius: 8
    },
    offerInfo: {
        display: "flex",
        flexDirection: "column"
    },
    offerPrice: {
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: 24,
        fontWeight: 600,
        marginBottom: 12
    },
    offerType: {
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: 20,
        fontWeight: 600,
        marginBottom: 8
    },
    offerDelivery: {
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: 16,
        fontWeight: 400,
        marginBottom: 12
    },
    offerDescription: {
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: 16,
        fontWeight: 400
    },
    buyerCard: {
        borderRadius: 8,
        padding: 16,
        marginBottom: 32
    },
    buyerTitle: {

        color: "rgba(0, 0, 0, 0.87)",
        fontSize: 24,
        fontWeight: 600,
        fontStyle: "semibold"
    },
    buyerName: {
        fontSize: 18,
        fontWeight: 500,
        marginBottom: 4,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    rating: {
        display: "flex",
        alignItems: "center",
        gap: 4
    },

    buttonGroup: {
        display: "flex",
        gap: 16
    },
    buyerButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 12,
        border: "2px solid #000",
        backgroundColor: "#fff",
        color: "#000",
        fontWeight: "bold",
        fontSize: 18,
        cursor: "pointer",
        width: 248,
        height: 60,
        gap: 10
    },


};
